import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import styles from './SettingField.css';

class SettingField extends React.Component {
  render() {
    const {
      input,
      meta,
      type,
      placeholder,
      readOnly,
      maxLength,
      dis = false,
      inputClassName,
      feedbackClassName,
      prefixText,
      prefixTextClassName,
      prefixTextClassNameError,
      showTextError,
      showEyeIcon,
      autoComplete,
    } = this.props;
    const { touched, error } = meta;
    return (
      <div
        className={
          touched
            ? error
              ? 'has-feedback has-error'
              : 'has-feedback has-success'
            : showEyeIcon
            ? 'has-feedback'
            : ''
        }
      >
        {prefixText && (
          <div
            className={
              touched
                ? error
                  ? prefixTextClassNameError
                  : prefixTextClassName
                : prefixTextClassName
            }
          >
            {prefixText}
          </div>
        )}
        <input
          {...input}
          type={
            showEyeIcon ? (this.state.showPassword ? 'password' : 'text') : type
          }
          readOnly={readOnly}
          maxLength={maxLength}
          className={`form-control ${inputClassName}`}
          placeholder={placeholder}
          onChange={this._onChange}
          onKeyPress={this._onKeyPress}
          disabled={dis}
          autoComplete={autoComplete}
        />

        {touched ? (
          showTextError || showEyeIcon ? (
            error && <small className="error">{error}</small>
          ) : error ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip">{error}</Tooltip>}
            >
              <span
                className={`form-control-feedback glyphicon glyphicon-remove ${feedbackClassName}`}
                style={{ 'pointer-events': 'auto', cursor: 'pointer' }}
              />
            </OverlayTrigger>
          ) : (
            <span
              className={`form-control-feedback glyphicon glyphicon-ok ${feedbackClassName}`}
            />
          )
        ) : (
          ''
        )}
        {showEyeIcon && (type === 'password' || type === 'text') && (
          <div className={styles.eyes} onClick={this._toggleEye}>
            {this.state.showPassword ? (
              <span className="glyphicon glyphicon-eye-close" />
            ) : (
              <span className="glyphicon glyphicon-eye-open" />
            )}
          </div>
        )}
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      showPassword: true,
    };
  }

  _toggleEye = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  _onKeyPress = e => {
    const { positiveNumberOnly, maxFractionDigits } = this.props;
    // allow only specific chars
    // whether the input is not valid (e.g. 123, or 1.234.1234) should be handled on onChange

    if (positiveNumberOnly) {
      let numberRegex;
      if (maxFractionDigits === 0) {
        numberRegex = /[0-9]/;
      } else {
        numberRegex = /[0-9.]/;
      }

      if (!numberRegex.test(e.key)) {
        e.preventDefault();
      }
    }
  };

  _onChange = e => {
    const nextVal = e.target.value;
    const {
      positiveNumberOnly,
      input: { onChange },
      maxFractionDigits,
    } = this.props;
    if (isNaN(nextVal) && positiveNumberOnly) {
      // case if one digit < 0 integer
      if (nextVal === '-') {
        onChange(e, '');
      } else {
        // no op. invalid change
      }
    } else if (maxFractionDigits !== undefined) {
      // we must check also if == 0, so we check using undefined instead of comparing zero values (!maxFractionDigits
      const dotPosition = nextVal.indexOf('.');
      if (
        dotPosition !== -1 &&
        nextVal.length - dotPosition - 1 > maxFractionDigits
      ) {
        // no op. invalid change
      } else {
        onChange(e, nextVal);
      }
    } else {
      onChange(e, nextVal);
    }
  };
}

export default SettingField;
